import { render, staticRenderFns } from "./SetConfig.vue?vue&type=template&id=8741ed0c&"
import script from "./SetConfig.vue?vue&type=script&lang=js&"
export * from "./SetConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports